/** Portable, non-HTML inline format. Raw HTML is always escaped. */
export function richHtml(value) {
    const escape = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    const safe = (s) => /^(\/(?!\/)[^\s"'<>]*|https:\/\/[^\s"'<>]+|mailto:[^\s"'<>]+|#[\w-]+)$/.test(s) && !(s.startsWith("/") && s.includes(".."));
    function render(src, depth) {
        if (depth > 12)
            return escape(src);
        let out = "", i = 0;
        while (i < src.length) {
            if (src[i] === "\\" && i + 1 < src.length) {
                out += escape(src[i + 1]);
                i += 2;
                continue;
            }
            const link = /^\[((?:\\.|[^\]\\\n])+)\]\(([^)\s]+)\)/.exec(src.slice(i));
            if (link) {
                out += safe(link[2]) ? `<a href="${escape(link[2])}">${render(link[1], depth + 1)}</a>` : render(link[1], depth + 1);
                i += link[0].length;
                continue;
            }
            const marker = ["**", "^^", "~~", "_"].find((m) => src.startsWith(m, i));
            if (marker) {
                let end = i + marker.length;
                while ((end = src.indexOf(marker, end)) >= 0 && src[end - 1] === "\\")
                    end += marker.length;
                if (end > i + marker.length) {
                    const tag = marker === "**" ? "strong" : marker === "^^" ? "u" : marker === "~~" ? "s" : "em";
                    out += `<${tag}>${render(src.slice(i + marker.length, end), depth + 1)}</${tag}>`;
                    i = end + marker.length;
                    continue;
                }
            }
            out += src[i] === "\n" ? "<br>" : escape(src[i]);
            i++;
        }
        return out;
    }
    return render(String(value ?? ""), 0);
}
/** Serialize only supported inline DOM; pasted styles and executable markup never persist. */
export function richValue(root) {
    function walk(node) {
        if (node.nodeType === 3)
            return (node.textContent ?? "").replace(/([\\*_^~\[\]])/g, "\\$1");
        if (node.nodeType !== 1)
            return "";
        const el = node;
        if (["SCRIPT", "STYLE", "IFRAME", "OBJECT"].includes(el.tagName))
            return "";
        const text = Array.from(el.childNodes).map(walk).join("");
        if (el.tagName === "BR")
            return "\n";
        if (["B", "STRONG"].includes(el.tagName))
            return `**${text}**`;
        if (["I", "EM"].includes(el.tagName))
            return `_${text}_`;
        if (el.tagName === "U")
            return `^^${text}^^`;
        if (["S", "STRIKE", "DEL"].includes(el.tagName))
            return `~~${text}~~`;
        if (el.tagName === "A") {
            const href = el.getAttribute("href") ?? "";
            if (/^(\/(?!\/)[^\s"'<>]*|https:\/\/[^\s"'<>]+|mailto:[^\s"'<>]+|#[\w-]+)$/.test(href) && !/[()]/.test(href))
                return `[${text}](${href})`;
        }
        return text + (["DIV", "P", "LI"].includes(el.tagName) ? "\n" : "");
    }
    return Array.from(root.childNodes).map(walk).join("").replace(/\u00a0/g, " ").replace(/\n$/, "");
}
